import { FC } from 'react';
import { Link } from 'react-router-dom';
import './Header.scss';

import mainLogo from 'assets/images/main-logo.svg';

import ConnectButton from './connectWallets/ConnectButton';
import MenuDropdown from './menuDropdown';

const Header: FC = () => {
  return (
    <div className="container header">
      <Link to="/" className="header-logo-link">
        <img src={mainLogo} alt="logo" />
      </Link>

      <div className="header-controls">
        <ConnectButton />
        <MenuDropdown />
      </div>
    </div>
  );
};

export default Header;
